<!--
	@name app-marketing
	@description Marketing page
	@date 2020/05/20
	@license no license
	@copywrite Answers In Retirement Limited
-->

<template>
	<div :component="$options.name">
		<v-carousel class="hero" hide-delimiters :show-arrows="$vuetify.breakpoint.mdAndUp" cycle continuous>
			<v-carousel-item class="main--carousel" @click="goToLeadGeneration">
				<v-container fill-height>
					<v-row no-gutters style="max-width: 750px;">
						<v-col cols="12" sm="12" class="pr-10">
							<div class="text-h3 text-lg-h2 white--text font-weight-bold mb-5">
								Need support in generating more leads?
							</div>
							<div class="text-h4 text-lg-h4 white--text font-weight-light" style="line-height: 42px;">
								Our marketing resources are crafted specifically to help you grow your business
							</div>
						</v-col>
					</v-row>
				</v-container>
			</v-carousel-item>
			<v-carousel-item class="lead--carousel" @click="goToLeadGeneration">
				<v-container fill-height>
					<v-row no-gutters>
						<v-col cols="12" class="text-center text-md-left" :style="{ 'justify-items': $vuetify.breakpoint.lgAndUp ? 'end' : 'auto' }">
							<div :style="{ 'max-width': $vuetify.breakpoint.lgAndUp ? '750px' : 'auto' }">
								<div class="text-h3 text-lg-h2 white--text font-weight-bold mb-5">
									Grow Your Business with Ready to go Appointments
								</div>
								<div class="text-h4 text-lg-h4 white--text font-weight-light" style="line-height: 42px;">
									Access more qualified consumers and spend less time chasing them
								</div>
								<v-row no-gutters>
									<v-col class="grow py-0">
										<v-btn color="white" outlined class="mt-10" large @click="goToLeadGeneration">
											click here to learn more
										</v-btn>
									</v-col>
									<v-col class="shrink d-none d-lg-block py-0 pr-8 align-self-end">
										<img class="d-block" :src="'manager_documents/fcda3994-c4b1-4b68-ba60-1cc4007b33b7.png' | urlize" style="height: 80px; position: relative; top: 6px;" />
									</v-col>
								</v-row>
							</div>
						</v-col>
					</v-row>
				</v-container>
			</v-carousel-item>
		</v-carousel>

		<v-container class="py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<p class="mx-auto text-h5 text-center text-md-h4 text-lg-h3 font-weight-bold mb-10" style="max-width: 900px;" :style="{ 'line-height': $vuetify.breakpoint.lgAndUp ? '3.75rem' : 'auto' }">
				Unlock expert marketing strategies today
			</p>
			<v-row>
				<v-col order="last" cols="12" md="7">
					<div class="d-block rounded" style="padding:56.25% 0 0 0;position:relative; overflow: hidden;">
						<iframe src="https://player.vimeo.com/video/1063238398?h=bf2934854a&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" frameborder="0" allow="autoplay;fullscreen; picture-in-picture; clipboard-write; encrypted-media" style="position:absolute;top:0;left:0;width:100%;height:100%;" />
					</div>
				</v-col>
				<v-col order="first" cols="12" md="5" class="pr-md-15 text-center align-self-center text-sm-left">
					<p class="text-h6 bypass--line-height--override text-md-h5 font-weight-medium mb-4" :style="{ 'line-height': $vuetify.breakpoint.lgAndUp ? '2.5rem' : 'auto' }">
						At Air, we help you communicate with your clients effectively through expertly designed marketing materials. Whether it's a simple campaign or a multi-channel strategy,
						<span class="font-weight-black primary--text">we provide the tools and support you need to grow your business</span>.
					</p>
				</v-col>
			</v-row>
			<div class="mt-15 mt-md-12 text-center mx-n3">
				<v-btn :large="$vuetify.breakpoint.mdAndUp" color="#1b78d8" dark class="mx-3" @click="goToMarketing">
					click here to learn more today
				</v-btn>
				<v-btn :large="$vuetify.breakpoint.mdAndUp" target="_blank" color="#1b78d8" outlined class="mx-3" @click="handleCtaClick({ function: 'arrangeDemo', subject: 'Discuss the resources available' })">
					request a callback to discuss the resources available
				</v-btn>
			</div>
		</v-container>

		<v-container>
			<v-divider />
		</v-container>

		<v-container v-if="sections" class="section3 py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<div class="text-center text-sm-left d-flex align-center flex-column mx-auto mb-10">
				<p class="text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-6">
					What you'll get
				</p>
				<p class="text-center text-body-1 bypass--line-height--override text-md-h6 font-weight-regular">
					Our marketing resources are crafted specifically to support you in building your later life lending business or working with introducers to do so — ensuring you have the right tools to stand out. Whether you're focusing on later life lending, or working with financial advisers or residential mortgage broker introducers, our marketing support gives you the edge.
				</p>
			</div>
			<div class="d-flex flex-wrap ma-n3">
				<v-card
					v-for="section in sections"
					:key="section.id"
					flat
					class="ma-3 flex-grow-1 flex-shrink-1 d-flex flex-column"
					:style="{ 'flex-basis': $vuetify.breakpoint.lgAndUp ? '30%' : $vuetify.breakpoint.mdOnly ? '40%' : '100%' }"
					style="perspective: 800px;"
				>
					<div v-if="section.id === 'templates'" style="max-height: 280px;" class="svg svg--left background--wavy rounded pa-12 mb-6 mt-6 mt-md-0" :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '100%' : '300px' }">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 136">
							<path class="cls-1" d="M40,96.5h-22c-1.66,0-3,1.34-3,3s1.34,3,3,3h22c1.66,0,3-1.34,3-3s-1.34-3-3-3ZM18,46h22c1.66,0,3-1.34,3-3s-1.34-3-3-3h-22c-1.66,0-3,1.34-3,3s1.34,3,3,3ZM68,68.5H18c-1.66,0-3,1.34-3,3s1.34,3,3,3h50c1.66,0,3-1.34,3-3s-1.34-3-3-3ZM68,82.5H18c-1.66,0-3,1.34-3,3s1.34,3,3,3h50c1.66,0,3-1.34,3-3s-1.34-3-3-3ZM76,0H26C11.64,0,0,11.64,0,26v84c0,14.36,11.64,26,26,26h50c14.36,0,26-11.64,26-26V26C102,11.64,90.36,0,76,0ZM97,110c0,11.58-9.42,21-21,21H26c-11.58,0-21-9.42-21-21V26C5,14.42,14.42,5,26,5h50c11.58,0,21,9.42,21,21v84Z" />
							<rect class="cls-green cls-opaque" x="61" y="18" width="24" height="28" rx="7" ry="7" />
						</svg>
					</div>
					<div v-if="section.id === 'guides'" style="max-height: 280px;" class="svg svg--center background--wavy background--wavy--alt--2 rounded pa-12 mb-6 mt-6 mt-md-0" :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '100%' : '300px' }">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 102 136">
							<path class="cls-1" d="M83,18H19c-1.66,0-3,1.34-3,3v48c0,1.66,1.34,3,3,3h64c1.66,0,3-1.34,3-3V21c0-1.66-1.34-3-3-3ZM76,0H26C11.64,0,0,11.64,0,26v84c0,14.36,11.64,26,26,26h50c14.36,0,26-11.64,26-26V26c0-14.36-11.64-26-26-26ZM97,110c0,11.58-9.42,21-21,21H26c-11.58,0-21-9.42-21-21V26C5,14.42,14.42,5,26,5h50c11.58,0,21,9.42,21,21v84Z" />
							<path class="cls-green cls-opaque" d="M30.66,83.17c-3.34,1.18-6.66,4.84-8.78,7.58-.91-1.31-1.6-2.01-1.72-2.13-.95-.95-2.48-.95-3.44,0-.96.94-.97,2.49-.03,3.45.01.01,1.41,1.45,2.81,4.26.39.79,1.18,1.3,2.06,1.35.04,0,.09,0,.13,0,.83,0,1.61-.42,2.06-1.13,1.83-2.87,5.77-7.79,8.53-8.77,1.27-.45,1.94-1.84,1.49-3.11-.45-1.27-1.86-1.94-3.12-1.48ZM83,88.5h-40c-1.66,0-3,1.34-3,3s1.34,3,3,3h40c1.66,0,3-1.34,3-3s-1.34-3-3-3ZM30.66,101.32c-3.34,1.18-6.66,4.84-8.78,7.58-.91-1.31-1.6-2.01-1.72-2.13-.95-.95-2.48-.95-3.44,0-.96.94-.97,2.49-.03,3.45.01.01,1.41,1.45,2.81,4.26.39.79,1.18,1.3,2.06,1.35.04,0,.09,0,.13,0,.83,0,1.61-.42,2.06-1.13,1.83-2.87,5.77-7.79,8.53-8.77,1.27-.45,1.94-1.84,1.49-3.11-.45-1.27-1.86-1.94-3.12-1.48ZM82,105.5h-40c-1.66,0-3,1.34-3,3s1.34,3,3,3h40c1.66,0,3-1.34,3-3s-1.34-3-3-3Z" />
						</svg>
					</div>
					<div v-if="section.id === 'lead_gen'" style="max-height: 280px;" class="svg svg--right background--wavy background--wavy--alt rounded pa-12 mb-6 mt-6 mt-md-0" :style="{ 'max-width': $vuetify.breakpoint.mdAndUp ? '100%' : '300px' }">
						<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 140 140" class="path-origin-center">
							<path class="cls-1 path-animate path-origin-center" d="M64.69,11.45l2.69-2.67v18.37c0,1.44,1.17,2.6,2.62,2.6s2.62-1.16,2.62-2.6V8.77l2.69,2.67c1.02,1.02,2.68,1.02,3.7,0,1.02-1.01,1.02-2.66,0-3.68l-7.05-7.01c-.54-.53-1.25-.78-1.96-.75-.71-.03-1.42.22-1.96.75l-7.05,7.01c-1.02,1.02-1.02,2.66,0,3.68,1.02,1.02,2.68,1.02,3.7,0ZM27.33,67.4H8.83l2.69-2.67c1.02-1.02,1.02-2.66,0-3.68-1.02-1.02-2.68-1.02-3.7,0l-7.05,7.01c-.54.53-.78,1.24-.76,1.94-.03.7.22,1.41.76,1.94l7.05,7.01c1.02,1.02,2.68,1.02,3.7,0,1.02-1.02,1.02-2.66,0-3.68l-2.69-2.67h18.49c1.45,0,2.62-1.17,2.62-2.6s-1.17-2.6-2.62-2.6ZM90.11,36.21c-5.69-.33-31.68-.46-33.95-.32-2.11.08-4,.18-5.56.32-3.97.23-11.48,2.84-13.45,10.92-.74,2.29-1.19,5.03-1.19,8.38,0,0-.06,27.04,0,31.43,0,5.23,3.4,16.24,13.93,16.85,5.69.33,31.68.46,33.95.32,2.11-.08,4-.18,5.56-.32,3.97-.23,11.48-2.84,13.45-10.92.74-2.28,1.19-5.03,1.19-8.38,0,0,.06-27.04,0-31.43,0-5.23-3.4-16.24-13.93-16.84ZM98,90.29c-.05.41-.12.78-.21,1.15-1.79,5.19-5.66,6.73-9.17,6.99-.03,0-1.94.28-4.98.48-2.44.09-27.46.03-33.45-.31-7.47-.43-8.99-9.3-8.99-11.68-.06-4.42.25-32.56.8-37.2.05-.41.12-.78.21-1.15,1.79-5.19,5.66-6.73,9.17-6.99.04,0,1.94-.28,4.98-.48,2.44-.09,27.46-.03,33.45.31,7.47.43,8.99,9.3,8.99,11.68.06,4.42-.25,32.56-.8,37.2ZM75.31,128.55l-2.69,2.67v-18.37c0-1.44-1.17-2.6-2.62-2.6s-2.62,1.17-2.62,2.6v18.37l-2.69-2.67c-1.02-1.02-2.68-1.02-3.7,0-1.02,1.02-1.02,2.66,0,3.68l7.05,7.01c.54.53,1.25.78,1.96.75.71.03,1.42-.22,1.96-.75l7.05-7.01c1.02-1.02,1.02-2.66,0-3.68-1.02-1.02-2.68-1.02-3.7,0ZM139.23,68.06l-7.05-7.01c-1.02-1.02-2.68-1.02-3.7,0-1.02,1.02-1.02,2.66,0,3.68l2.69,2.67h-18.49c-1.45,0-2.62,1.16-2.62,2.6s1.17,2.6,2.62,2.6h18.49l-2.69,2.67c-1.02,1.02-1.02,2.66,0,3.68,1.02,1.02,2.68,1.02,3.7,0l7.05-7.01c.54-.53.78-1.24.76-1.94.03-.7-.22-1.41-.76-1.94Z" />
							<path class="cls-green cls-opaque" d="M92.8,86.52c-.04.33-.1.64-.17.94-1.45,4.23-4.61,5.48-7.47,5.69-.03,0-1.58.23-4.05.39-1.98.08-22.36.03-27.24-.26-6.08-.35-7.32-7.57-7.32-9.51-.05-3.6.21-26.51.65-30.29.04-.33.1-.64.17-.94,1.45-4.23,4.61-5.48,7.47-5.69.03,0,1.58-.23,4.06-.39,1.98-.08,22.36-.03,27.24.26,6.08.35,7.32,7.57,7.32,9.51.05,3.6-.2,26.51-.65,30.29" />
						</svg>
					</div>

					<v-card-title v-if="section.title" class="text-h6 text-md-h5 text-lg-h5 font-weight-bold flex-grow-0 text-center justify-center pt-0 pb-2">
						{{ section.title }}
					</v-card-title>

					<v-card-text class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular flex-grow-1 text-center pt-0 px-6 pb-0" style="line-height: 1.75rem;" v-html="$sanitize(section.copy)" />
				</v-card>
			</div>
			<div class="mt-15 mt-md-12 text-center mx-n3">
				<v-btn :large="$vuetify.breakpoint.mdAndUp" color="#1b78d8" dark class="mx-3" @click="goToMarketing">
					click here to get started
				</v-btn>
				<v-btn :large="$vuetify.breakpoint.mdAndUp" target="_blank" color="#1b78d8" dark outlined class="mx-3" @click="handleCtaClick({ function: 'arrangeDemo', subject: 'Book a demo on lead generation resources' })">
					book a demo on lead generation resources
				</v-btn>
			</div>
		</v-container>

		<v-container>
			<v-divider />
		</v-container>

		<v-container class="section4 py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<v-row>
				<v-col order="last" cols="12" md="5" class="align-self-center">
					<div class="mx-auto mt-6 mt-md-0">
						<div class="image--parallax rounded">
							<div class="image" />
						</div>
					</div>
				</v-col>
				<v-col order="first" cols="12" md="7" class="pr-md-15 text-center text-sm-left">
					<p class="text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-6">
						Unlock expert marketing tools with the Air Marketing Hub
					</p>
					<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-4">
						With 20 plus years of industry experience and deep customer insights, <span class="font-weight-bold">Air Marketing</span> gives you everything you need to market with confidence. Whether you're looking for high-impact templates or targeted solutions, our fully customisable resources help you connect, engage, and convert.
					</p>
					<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-medium mb-0">
						Personalise, download, or place an order for direct delivery to your door -
						<span class="font-weight-black primary--text">it's that simple.</span>
					</p>
					<div class="mt-10 text-xs-center text-md-left mx-n3">
						<v-btn :large="$vuetify.breakpoint.mdAndUp" color="#1b78d8" dark class="mx-3" @click="goToMarketing">
							visit the air marketing hub now
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</v-container>

		<v-container>
			<v-divider />
		</v-container>

		<v-container class="section5 py-8" :class="{ 'py-12': $vuetify.breakpoint.mdAndUp }" style="max-width: 1050px;">
			<v-row>
				<v-col order="first" cols="12" md="5" class="align-self-center">
					<div class="mx-auto mt-6 mt-md-0">
						<div class="image--parallax rounded">
							<div class="image image--2" />
						</div>
					</div>
				</v-col>
				<v-col order="last" cols="12" md="7" class="pl-md-15 text-center text-sm-left">
					<p class="text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-6">
						Boost your lead generation activities with Campaign in a Box
					</p>
					<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-4">
						Struggling to generate leads? Campaign in a Box makes it easy with professionally designed marketing assets and step-by-step instructions to help you plan, implement, and optimise your campaigns effortlessly.
					</p>
					<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-4">
						Each campaign includes ready-made materials such as emails, flyers, and social media graphics—plus expert guidance to help you maximise success.
					</p>
					<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-medium mb-0">
						Access campaign in a box through our learning platform -
						<span class="font-weight-black primary--text">Air Academy</span>
					</p>
					<div class="mt-10 text-xs-center text-md-left mx-n3">
						<v-btn :large="$vuetify.breakpoint.mdAndUp" color="#1b78d8" dark class="mx-3" @click="goToAcademy">
							use camapign in a box today
						</v-btn>
					</div>
				</v-col>
			</v-row>
		</v-container>

		<banner class="mt-10" :auth="auth" @handle-cta-click="handleCtaClick" />

		<div id="contact" ref="contact" class="header--waves scroll-margin--fixed-header-offset">
			<!--Content before waves-->
			<div class="inner-header flex">
				<v-container class="py-8" :class="{ 'py-15': $vuetify.breakpoint.mdAndUp }">
					<div class="text-md-center d-flex align-center flex-column">
						<div class="grey lighten-4 pa-8 rounded elevation-6" style="max-width: 700px;">
							<v-fade-transition>
								<div v-if="success">
									<p class="text-h6 text-md-h5 text-lg-h4 font-weight-bold mb-4 mx-auto" style="max-width: 500px;">
										Thank you for reaching out!
									</p>
									<p class="text-body-1 bypass--line-height--override text-md-h6 font-weight-regular mb-6 mx-auto" style="max-width: 500px;">
										Your email has been sent. We'll get back to you shortly. In the meantime, check out <a class="ga--trigger ga--campaign-click ga--events" @click="$router.push('/events')">upcoming events</a>.
									</p>
									<v-icon color="success" size="60">
										mdi-check-circle
									</v-icon>
								</div>
							</v-fade-transition>
							<template v-if="!success">
								<p class="text-center text-h6 font-weight-regular mb-6 mx-0" v-html="$sanitize(form.copy)" />
								<validation-observer ref="observer">
									<v-form @submit.prevent="submit">
										<v-row>
											<v-col cols="12" md="6">
												<validation-provider v-slot="{ errors }" name="First Name" rules="required">
													<v-text-field v-model="firstName" :disabled="disabled" :error-messages="errors" label="First Name" :hide-details="!errors?.length" filled />
												</validation-provider>
											</v-col>
											<v-col cols="12" md="6">
												<validation-provider v-slot="{ errors }" name="Last Name" rules="required">
													<v-text-field v-model="lastName" :disabled="disabled" :error-messages="errors" label="Last Name" :hide-details="!errors?.length" filled />
												</validation-provider>
											</v-col>
											<v-col cols="12">
												<validation-provider v-slot="{ errors }" name="Firm Name" rules="required">
													<v-text-field v-model="firmName" :disabled="disabled" :error-messages="errors" label="Firm Name" :hide-details="!errors?.length" filled />
												</validation-provider>
											</v-col>
											<v-col cols="12">
												<validation-provider v-slot="{ errors }" name="FCA Number" rules="required|numeric|min:6|max:7">
													<v-text-field v-model="fcaNumber" :disabled="disabled" :error-messages="errors" label="FCA Number" :hide-details="!errors?.length" filled />
												</validation-provider>
											</v-col>
											<v-col cols="12">
												<validation-provider v-slot="{ errors }" name="Email" rules="required|email">
													<v-text-field v-model="email" :disabled="disabled" :error-messages="errors" label="Email" :hide-details="!errors?.length" filled />
												</validation-provider>
											</v-col>
											<v-col cols="12">
												<validation-provider v-slot="{ errors }" name="Phone" rules="required|numeric">
													<v-text-field v-model="phone" :disabled="disabled" :error-messages="errors" label="Phone" :hide-details="!errors?.length" filled />
												</validation-provider>
											</v-col>
											<v-col cols="12">
												<v-btn class="ga--trigger ga--campaign-click ga--form-submit white--text" color="#1b78d8" :disabled="disabled" :loading="loading" type="submit" large block>
													Submit for a call back
												</v-btn>
											</v-col>
										</v-row>
									</v-form>
								</validation-observer>
							</template>
						</div>
					</div>
				</v-container>
			</div>

			<!--Waves Container-->
			<div>
				<svg
					class="waves"
					xmlns="http://www.w3.org/2000/svg"
					xmlns:xlink="http://www.w3.org/1999/xlink"
					viewBox="0 24 150 28"
					preserveAspectRatio="none"
					shape-rendering="auto"
				>
					<defs>
						<path id="gentle-wave" d="M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z" />
					</defs>
					<g class="parallax">
						<use xlink:href="#gentle-wave" x="48" y="0" fill="rgba(255,255,255,0.7" />
						<use xlink:href="#gentle-wave" x="48" y="3" fill="rgba(255,255,255,0.5)" />
						<use xlink:href="#gentle-wave" x="48" y="5" fill="rgba(255,255,255,0.3)" />
						<use xlink:href="#gentle-wave" x="48" y="7" fill="#fff" />
					</g>
				</svg>
			</div>
			<!--Waves end-->
		</div>
		<div class="body--waves d-flex" />

		<common-dialog-login ref="login" :submit-button-text="loginCtaText" :submit-button-color="'#1b78d8'" :submit-button-dark="true" @login-success="loginSuccess">
			<template #copy>
				<p class="text-body-1 font-weight-regular" v-html="loginCopy" />
			</template>
		</common-dialog-login>
	</div>
</template>

<script>
	import { mapActions } from 'vuex';
	import { gsap } from 'gsap';
    import ScrollTrigger from "gsap/ScrollTrigger";
	import Banner from '@/component/app/air-later-life/marketing/banner';
	import { ValidationObserver, ValidationProvider } from 'vee-validate';
	import { EventBus, ElementTools } from '@/utils';
	import CommonDialogLogin from '@/component/common/dialog/login';

	export default {
		name: 'app-marketing',

		components: {
			Banner,
			ValidationObserver,
            ValidationProvider,
			CommonDialogLogin
		},

		data() {
			return {
				auth: null,
				destination: null,
				loginCopy: null,
				loginCtaText: 'Proceed',
                timelines: [],
				form: {
                    "copy": "Contact a member of the team if you'd like to <strong>know more about Air Marketing</strong> or for support using any of the resources available"
                },
                campaign: 'Marketing Page',
                subject: null,
                firstName: '',
				lastName: '',
				firmName: '',
				fcaNumber: '',
				email: '',
				phone: '',
				message: '',
				loading: false,
				success: false,
				disabled: false,
				nurtureMarketingMaterials: ['Database email template', 'Direct mail templates', 'Local press adverts', 'Event/door drop leaflets', 'Event banners'],
				referralMarketingMaterials: ['Equity release brochure', 'Customer leaflets', 'Opportunities leaflet', 'Case studies', 'Email/social media', 'Event banners'],
				sections: [
                    {
                        "id": "templates",
                        "title": "Customisable Templates",
                        "copy": `<p class="mb-0">Professionally designed, ready to use. From client emails to flyer campaigns, our templates make it easy to create polished, high-converting marketing materials—effortlessly.</p>`,
                        "show": true,
                        "ctas": [
                            {
                                "copy": "Arrange a demo",
                                "color": "primary",
                                "function": "arrangeDemo"
                            },
                            {
                                "copy": "Let's chat!",
                                "color": "secondary",
                                "function": "openChat"
                            }
                        ],
                        "poster": "/cms/AIR+Campaign+Video+Screen_001a.jpg"
                    },
                    {
                        "id": "guides",
                        "title": "Engaging Guides",
                        "copy": `<p class="mb-0">Simplify complex topics, build trust, and showcase your expertise with expertly designed client guides—perfect for educating and nurturing leads.</p>`,
                        "show": true,
                        "ctas": [
                            {
                                "copy": "Arrange a demo",
                                "color": "primary",
                                "function": "arrangeDemo"
                            },
                            {
                                "copy": "Let's chat!",
                                "color": "secondary",
                                "function": "openChat"
                            }
                        ],
                        "poster": "/cms/AIR+Campaign+Video+Screen_001a.jpg"
                    },
                    {
                        "id": "lead_gen",
                        "title": "Lead Generation Support",
                        "copy": `<p class="mb-0">Attract high-quality leads and drive conversions with powerful tools like our 'Campaign in a Box'—designed to nurture relationships and grow your business.</p>`,
                        "show": true,
                        "ctas": [
                            {
                                "copy": "Arrange a demo",
                                "color": "primary",
                                "function": "arrangeDemo"
                            },
                            {
                                "copy": "Let's chat!",
                                "color": "secondary",
                                "function": "openChat"
                            }
                        ],
                        "poster": "/cms/AIR+Campaign+Video+Screen_001a.jpg"
                    }
                ],
				testimonials: [
					{
						copy: `The knowledge I gained of the Later Life Lending products, processes and tools available to support the journey has given me confidence in my abilities to advise correctly.`,
						name: `Donna Murray`
					},
					{
						copy: `I have really enjoyed completing the modules as they have helped me gain a great deal of knowledge of the products available and compliance required which has given me confidence in dealing with later life lending.`,
						name: `Collette Campbell`
					},
					{
						copy: `I would recommend the Air Later Life Lending Adviser Accelerator to anyone who is considering advising on Later Life Lending`,
						name: `Graham Pike`
					},
					{
						copy: `Honestly, I think that everyone in Later Life Lending should be going through this course`,
						name: `Kris Buda`
					}
				]
			};
		},

		computed: {},

		mounted() {
            this.scrollTriggerInit();
        },

		created() {
			this.auth = window.localStorage.getItem('air.authorization');
		},

		methods: {
			...mapActions('ContactCampaign', ['submitContactCampaign']),

			scrollTriggerInit() {
                let mm = gsap.matchMedia();
                gsap.registerPlugin(ScrollTrigger);

                mm.add("(min-width: 1200px)", () => {
                    let t2 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.section3',
                            start: 'top+=500 bottom',
							end: 'top-=100',
                            scrub: true
                        },
                        defaults: { ease: 'none'}
                    });

                    // animate the container one way...
                    t2
                        .from('.section3 .svg--left', { duration: 0.25, opacity: 0, transform: 'rotateY(10deg)' })
                        .from('.section3 .svg--center', { duration: 0.25, opacity: 0, transform: 'rotateX(10deg)' }, "<")
                        .from('.section3 .svg--right', { duration: 0.25, opacity: 0, transform: 'rotateY(-10deg)' }, "<")
                        .from('.section3 .svg--left .cls-1', { duration: 0.35, opacity: 0, scale: 0.8, transformOrigin: "center center" }, "<")
                        .from('.section3 .svg--center .cls-1', { duration: 0.35, opacity: 0, scale: 0.8, transformOrigin: "center center" }, "<")
                        .from('.section3 .svg--right .cls-1', { duration: 0.35, rotation: -25, ease: 'back.out(1.75)' }, "<")
                        .from('.section3 .svg--left .cls-green', { duration: 0.35, opacity: 0, x: -5, y: 8, scale: 0.8, transformOrigin: "center center", ease: 'back.out(1.75)' }, "<+=0.1")
                        .from('.section3 .svg--center .cls-green', { duration: 0.35, opacity: 0, y: -8, scale: 0.8, transformOrigin: "center center", ease: 'back.out(1.75)' }, "<+=0.1")
                        .from('.section3 .svg--right .cls-green', { duration: 0.35, opacity: 0, scale: 0.8, transformOrigin: "center center", ease: 'back.out(1.75)' }, "<");
                    this.timelines.push(t2);

					let t3 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.section4',
                            start: 'top bottom',
							end: 'bottom bottom+200',
							scrub: true
                        }
                    });
                    t3.from('.section4 .image--parallax .image', { duration: 0.25, scale:1 });
                    this.timelines.push(t3);

					let t4 = gsap.timeline({
                        scrollTrigger: {
                            trigger: '.section5',
                            start: 'top bottom',
							end: 'bottom bottom+200',
							scrub: true
                        }
                    });
                    t4.from('.section5 .image--parallax .image', { duration: 0.25, scale:1 });
                    this.timelines.push(t4);
                });
            },

            handleCtaClick(cta) {
				if (cta.function) {
					let fnctn = cta.function;
					if (fnctn === 'arrangeDemo') this.scrollToAnchorPoint('contact', cta.subject || null);
					if (fnctn === 'openChat') EventBus.$emit('open-chat');
					else if (typeof this[fnctn] === "function") this[fnctn]();
				} else if (cta.route) {
					let route = cta.route;
					if (this.auth && cta.authRoute) {
						route = cta.authRoute;
						this.$router.push(route);
					} else {
						this.$router.push(route);
					}
				}
			},

            scrollToAnchorPoint(refName, subject = null) {
				if (subject) this.subject = subject;
                const id = refName;
                const yOffset = -140;
                const element = document.getElementById(id);
                const y = element.getBoundingClientRect().top + window.scrollY + yOffset;

                window.scrollTo({top: y, behavior: 'smooth'});
            },


			submit() {
				this.$refs.observer.validate().then(async(valid) => {
					if (!valid) return false;

					this.success = false;
					this.loading = true;

					this.submitContactCampaign({
						firstName: this.firstName,
						lastName: this.lastName,
						firmName: this.firmName,
						fcaNumber: this.fcaNumber,
						email: this.email,
						phone: this.phone,
						campaign: this.campaign,
						subject: this.subject
					})
						.then(() => {
							this.success = true;
							this.resetForm();
						})
						.catch(() => ElementTools.fireNotification(this.$el, 'error', 'An error occurred. Please try again later.'))
						.finally(() => {
							this.subject = null;
							this.loading = false;
						});
				});
			},

			resetForm() {
				this.subject = null;
				this.firstName = '';
				this.lastName = '';
				this.firmName = '';
				this.fcaNumber = '';
				this.email = '';
				this.phone = '';
				this.disabled = true;
				this.$refs.observer.reset();
			},

			goToMarketing() {
				this.destination = '/club?section=marketing';
				this.loginCopy = 'As an Air member, you already have <strong>free</strong> access to the latest templates and support material. Log in below to explore the resources available.';
				this.loginCtaText = 'Proceed to Air Marketing';
				if (this.auth) this.$router.push(this.destination);
				else this.$refs.login.open();
			},

			goToAcademy() {
				this.destination = '/academy';
				this.loginCopy = 'As an Air member, you already have <strong>free</strong> access to the latest templates and support material. Log in below to explore the resources available.';
				this.loginCtaText = 'Proceed to Air Marketing';
				if (this.auth) this.$router.push(this.destination);
				else this.$refs.login.open();
			},

			goToLeadGeneration() {
				this.destination = '/club?section=leadGeneration';
				this.loginCopy = 'Log in below to find out more about the Lead Tech partnership and <strong>exclusive offer</strong> for Air members.';
				this.loginCtaText = 'Proceed';
				if (this.auth) this.$router.push(this.destination);
				else this.$refs.login.open();
			},

			loginSuccess() {
				this.auth = window.localStorage.getItem('air.authorization');
				this.$refs.login.close();
				this.$router.push(this.destination);
			}
		}
	};
</script>

<style lang="scss" scoped>
	.image--parallax {
		position: relative;
		min-height: 400px;
		width: 100%;
		overflow: hidden;

		.image {
			position: absolute;
			left: -40px;
			right: -40px;
			top: -40px;
			bottom: -40px;
			width: calc(100% + 40px);
			scale: 1.2;
			background-size: cover;
			background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/03621404-5274-4295-8e70-9cf18249c08d.png');
		}

		.image--2 {
			position: absolute;
			left: -40px;
			right: -40px;
			top: -40px;
			bottom: -40px;
			width: calc(100% + 40px);
			scale: 1.1;
			background-size: cover;
			background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/7c33a8fc-cf98-48a7-ba19-0602f999595c.png');
		}
	}

    .hero {
        position: relative;
        overflow: hidden;
        z-index: 1;
        height: 300px;
        border-bottom: 20px solid #1b78d8;
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL + '/manager_documents/c710e590-fb3a-45f3-84be-5ae0e8d7d265.png');
    }

	.main--carousel {
        background-position: 50% 50%;
        background-repeat: no-repeat;
        background-size: cover;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL + '/manager_documents/ead2bb82-d729-432c-a432-afcc4c85bfd9.png');
	}

	.lead--carousel {
		background-position: 100% 50%;
		background-size: cover;
		background-repeat: repeat;
		background-blend-mode: normal;
		background-image:
		url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/1df29e2d-bcf4-4084-8140-e68fcb8cf15c.jpg');
	}

	.card--number {
		overflow: hidden;
		box-shadow: 0px 6px 8px 2px rgba(0, 0, 0, 0.25);

		&::after {
			content: "";
			position: absolute;
			width: 100%;
			height: 100%;
			background: linear-gradient(rgba(0,0,0,0) 50%, rgba(0,0,0,0.25) 50%, rgba(0,0,0,0.75));
			top: 0;
			left: 0;
		}
	}

	.background--wavy {
		background-color: #3f3195;
		background-position: 50% 50%;
		background-size: cover;
		background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/7aed7769-4814-4c94-bc82-6db969ef5dda.png');

		&--alt {
			background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/4f349c68-854f-4f1d-ad40-afe568de8fed.png');
		}

		&--alt--2 {
			background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/73959188-6cd2-46b4-8091-5241e24ab0a7.png');
		}

		svg {
			display: block;
		}
	}

    #gradient {
        --color-stop-1: #5354c0;
        --color-stop-2: #372387;
    }

    #gradient--alt {
        --color-stop-1: #5354c0;
        --color-stop-2: #372387;
    }

    #gradient--line {
        --color-stop-3: #1eb0e1;
        //--color-stop-4: #61e37a;
        --color-stop-4: #61e37a;
    }

    .svg {
		svg {
			display: block;
			width: 100%;
			height: 100%;
		}
        .gradient {
            fill: url(#gradient) #3f3195;
        }

        .gradient--alt {
            fill: url(#gradient--alt) #372387;
        }

        .gradient--line {
            fill: url(#gradient--line) #372387;
        }

        .cls-1 {
			fill: #f9f8f4;
        }

        .cls-3 {
			fill: #3f3195;
        }

        .cls-4 {
			fill: #1eb0e1;
        }

        .cls-5 {
			fill: #c0eefb;
        }

        .cls-6 {
			fill: #60d4f4;
        }

        .cls-7 {
			fill: #54addd;
        }

        .cls-9 {
			fill: #8065d5;
        }

		.cls-green {
			fill: #61e37a;
        }

		.cls-opaque {
			opacity: 0.8;
		}

        #billion {
            animation:pulse 10s linear infinite;
            transform-origin: center;
        }

        .spinner {
            animation:spin 24s linear infinite;
            transform-origin: center;
        }

		.path-origin-center {
			transform-origin: 25% 25% !important;
		}
    }

	#overlay {
		position: absolute;
		top: 0;
		left: 0;
		height: 100%;
		width: 100%;
		background-color: transparent;
		background-image: linear-gradient(340deg, #6464645c 45%, #1eb0e1 100%);
		opacity: 1;
		mix-blend-mode: multiply;
		transition: background 0.3s, border-radius 0.3s, opacity 0.3s;
	}

	.header--waves {
        background-position: 50% 50%;
        background-size: cover;
        background-attachment: fixed;
        background-image: url($VUE_APP_S3_AIR_ASSETS_URL+'/manager_documents/d0bb7b46-b858-45ac-8e11-15f9c7883eb7.png');
        position:relative;
    }

    .inner-header {
        width:100%;
        margin: 0;
        padding: 0;
    }

    .waves {
        position:relative;
        width: 100%;
        height:50px;
        margin-bottom:-7px; /*Fix for safari gap*/
        min-height:50px;
        max-height:50px;
    }

    .body--waves {
        position:relative;
        height:50px;
        text-align:center;
        background-color: white;
    }

	    /* Animation */
		.parallax > use {
        animation: move-forever 25s cubic-bezier(.55,.5,.45,.5)     infinite;
    }
    .parallax > use:nth-child(1) {
        animation-delay: -2s;
        animation-duration: 7s;
    }
    .parallax > use:nth-child(2) {
        animation-delay: -3s;
        animation-duration: 10s;
    }
    .parallax > use:nth-child(3) {
        animation-delay: -4s;
        animation-duration: 13s;
    }
    .parallax > use:nth-child(4) {
        animation-delay: -5s;
        animation-duration: 20s;
    }
    @keyframes move-forever {
        0% {
        transform: translate3d(-90px,0,0);
        }
        100% {
            transform: translate3d(85px,0,0);
        }
    }
    /*Shrinking for mobile*/
    @media (max-width: 768px) {
        .waves {
            height:40px;
            min-height:40px;
        }
        .body--waves {
            height:30vh;
        }
    }
</style>
